import React from 'react'
import { Error, Error2, IconError } from './Styled'
import en from 'config/strings';

/**
 * Error (form field validation message)
 * Displays a validation error below form fields. Used internally by Input, Select,
 * AutoComplete, DatePicker, and other form components via `<Error {...props} />`.
 *
 * **How it works**
 * - Renders only when **both** `touched` and `error` are truthy.
 * - Shows an error icon + message text.
 * - Uses alternate styling (`Error2`) for the soft-required message (`en.require2`).
 *
 * Exported as `Error` from `components/Form`. Internal name: `ErrorField`.
 *
 * @param {Object} props
 * @param {boolean} props.touched - Whether the field was interacted with (from form state).
 * @param {string} [props.error] - Validation error message. Hidden when empty.
 * @example
 * // Inside a form field component
 * <Error touched={touched} error={errors.email} />
 * @example
 * // Typical usage — spread full field props
 * <Error {...props} />
 */
const ErrorField = (props) => {
    const {
        touched,
        error
    } = props;

    return (
        touched && error ?
            (error == en.require2 ?
                <Error2> <IconError />{error}</Error2 > :
                <Error> <IconError />{error}</Error >) :
            null
    )

}

export default ErrorField